/**
 * Portal API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: v1
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { observable, action, runInAction } from 'mobx';
import { inject, injectable, optional } from 'inversify';
import axios, { AxiosPromise, AxiosRequestConfig } from 'axios';

import { ErrorInfo } from '../model/errorInfo';
import { FinancingPlanModel } from '../model/financingPlanModel';
import { LoanApplication } from '../model/loanApplication';
import { LoanApplicationRead } from '../model/loanApplicationRead';
import { LoanDocument } from '../model/loanDocument';
import { SignDocumentsData } from '../model/signDocumentsData';
import { Stream } from '../model/stream';
import { SubmitApplicationResult } from '../model/submitApplicationResult';

import { BASE_PATH, COLLECTION_FORMATS } from '../variables';
import { Configuration, ErrorStatusMap, ExtraAxiosConfig } from '../configuration';


@injectable()
export class FinancingAPIService {

    protected basePath = '';
    protected configuration = new Configuration();

    constructor(@inject(BASE_PATH) @optional() basePath: string, @optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }


    @observable
    public generateLoanDocumentObservable: LoanDocument | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public generateLoanDocument(id: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<LoanDocument> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling generateLoanDocument.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<LoanDocument>(
            `${this.basePath}/api/financing-bridge/loans/${encodeURIComponent(String(id))}/document`,
            null,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.generateLoanDocumentObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getLoanApplicationObservable: LoanApplicationRead | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public getLoanApplication(id: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<LoanApplicationRead> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getLoanApplication.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<LoanApplicationRead>(
            `${this.basePath}/api/financing-bridge/loans/${encodeURIComponent(String(id))}`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getLoanApplicationObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getLoanDocumentFileObservable: Stream | undefined = undefined;

    /**
     * 
     * 
     * @param id 
     */
    @action
    public getLoanDocumentFile(id: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Stream> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling getLoanDocumentFile.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Stream>(
            `${this.basePath}/api/financing-bridge/loans/${encodeURIComponent(String(id))}/documentfile`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getLoanDocumentFileObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getSelectedPlansObservable: Array<FinancingPlanModel> | undefined = undefined;

    /**
     * 
     * 
     * @param financingProvider 
     */
    @action
    public getSelectedPlans(financingProvider: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<FinancingPlanModel>> {
        if (financingProvider === null || financingProvider === undefined) {
            throw new Error('Required parameter financingProvider was null or undefined when calling getSelectedPlans.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<FinancingPlanModel>>(
            `${this.basePath}/api/financing-bridge/plans/${encodeURIComponent(String(financingProvider))}/selected`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getSelectedPlansObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public getSelectedProductsObservable: Array<string> | undefined = undefined;

    /**
     * 
     * 
     * @param financingProvider 
* @param businessUnitId 
     */
    @action
    public getSelectedProducts(financingProvider: string, businessUnitId?: string, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<Array<string>> {
        if (financingProvider === null || financingProvider === undefined) {
            throw new Error('Required parameter financingProvider was null or undefined when calling getSelectedProducts.');
        }

        const queryParameters: {[index: string]: any} = {};
        if (businessUnitId !== undefined) {
            queryParameters['businessUnitId'] = businessUnitId;
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
        ];

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            params: queryParameters,
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.get<Array<string>>(
            `${this.basePath}/api/financing-bridge/products/${encodeURIComponent(String(financingProvider))}/selected`,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.getSelectedProductsObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public signDocumentObservable: any = undefined;

    /**
     * 
     * 
     * @param id 
* @param body 
     */
    @action
    public signDocument(id: string, body?: SignDocumentsData, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling signDocument.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<any>(
            `${this.basePath}/api/financing-bridge/${encodeURIComponent(String(id))}/signatures`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.signDocumentObservable = response.data);
            }
            return response;
        });
    }


    @observable
    public signDocument_1Observable: any = undefined;

    /**
     * 
     * 
     * @param id 
* @param body 
     */
    @action
    public signDocument_1(id: string, body?: SignDocumentsData, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<any> {
        if (id === null || id === undefined) {
            throw new Error('Required parameter id was null or undefined when calling signDocument_1.');
        }

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<any>(
            `${this.basePath}/api/financing-bridge/loans/${encodeURIComponent(String(id))}/signatures`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.signDocument_1Observable = response.data);
            }
            return response;
        });
    }


    @observable
    public submitApplicationObservable: SubmitApplicationResult | undefined = undefined;

    /**
     * 
     * 
     * @param body 
     */
    @action
    public submitApplication(body?: LoanApplication, showBusy?: boolean, errorStatusMap?: ErrorStatusMap): AxiosPromise<SubmitApplicationResult> {

        const headers: {[index: string]: string} = {};

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers['Accept'] = httpHeaderAcceptSelected;
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json-patch+json',
            'application/json',
            'text/json',
            'application/_*+json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers['Content-Type'] = httpContentTypeSelected;
        }

        const configWithExtra: AxiosRequestConfig & ExtraAxiosConfig = {
            withCredentials: this.configuration.withCredentials,
            headers,
            showBusy,
            errorStatusMap
        };
        const config = configWithExtra as AxiosRequestConfig;

        return axios.post<SubmitApplicationResult>(
            `${this.basePath}/api/financing-bridge/loans`,
            body,
            config
        ).then(response => {
            if (response.data) {
                runInAction(() =>  this.submitApplicationObservable = response.data);
            }
            return response;
        });
    }

}
